import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  hasAnySim,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSim,
} from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form/field/SimNaoRadioGroupField'

import {
  ConsultaSeguimentoPergunta09Model,
  ConsultaSeguimentoPergunta09TrazPraVoceEnum,
} from './model-consultaSeguimentoPergunta09'

const pergunta09TrazPraVoceEnumValues = Object.values(ConsultaSeguimentoPergunta09TrazPraVoceEnum)

export function isPergunta09TrazPraVoceAllNao(value: ConsultaSeguimentoPergunta09Model): boolean {
  const isExemplosAllNao = isAllNao(value?.PERGUNTA_09_TRAZ_PRA_VOCE, pergunta09TrazPraVoceEnumValues)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosAllNao
}

export function hasPergunta09TrazPraVoceAnySim(value: ConsultaSeguimentoPergunta09Model): boolean {
  return hasAnySim(value?.PERGUNTA_09_TRAZ_PRA_VOCE) || isPerguntaOutroSim(value?.OUTRO)
}

export function prunePergunta09(value: ConsultaSeguimentoPergunta09Model): ConsultaSeguimentoPergunta09Model {
  const pruned: ConsultaSeguimentoPergunta09Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_09_HEADER: value.PERGUNTA_09_HEADER,
    PERGUNTA_09_TRAZ_PRA_VOCE: value.PERGUNTA_09_TRAZ_PRA_VOCE,
    OUTRO: value.OUTRO,
  }

  if (hasPergunta09TrazPraVoceAnySim(value)) {
    pruned.PERGUNTA_09_SO_PARA_MOSTRAR = value.PERGUNTA_09_SO_PARA_MOSTRAR
  }

  return pruned
}

export function conditionToCalculatePergunta09(values: ConsultaSeguimentoPergunta09Model): boolean {
  if (
    !isEmpty(values.PERGUNTA_09_HEADER) &&
    ((hasPergunta09TrazPraVoceAnySim(values) && !isEmpty(values.PERGUNTA_09_SO_PARA_MOSTRAR)) ||
      isPergunta09TrazPraVoceAllNao(values))
  ) {
    return true
  }
  return false
}

export function calculateResultadoPergunta09(values: ConsultaSeguimentoPergunta09Model): PassouFalhouEnum | undefined {
  const hasTrazPraVoceAnySim = hasPergunta09TrazPraVoceAnySim(values)

  if (
    isPergunta09TrazPraVoceAllNao(values) ||
    (hasTrazPraVoceAnySim && values.PERGUNTA_09_SO_PARA_MOSTRAR === SimNaoEnum.NAO)
  ) {
    return PassouFalhouEnum.FALHOU
  }

  if (hasTrazPraVoceAnySim && values.PERGUNTA_09_SO_PARA_MOSTRAR === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  }
}
